import { makeStyles } from '@material-ui/core/styles';

import { greenMark } from 'theme';

export const useTextFieldQuestionFormStyles = makeStyles(theme => ({
  validationIconEnabled: {
    color: greenMark,
  },
  validationIconButton: {
    '&.Mui-disabled': {
      backgroundColor: 'transparent',
      opacity: 0.5,
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  header: {
    color: theme.palette.common.gray700,
    fontSize: '14px',
    fontWeight: 500,
  },
}));
